import { render, staticRenderFns } from "./ActiveTag.vue?vue&type=template&id=01569a66&scoped=true&"
import script from "./ActiveTag.vue?vue&type=script&lang=js&"
export * from "./ActiveTag.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTag.vue?vue&type=style&index=0&id=01569a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01569a66",
  null
  
)

export default component.exports